import React, { useState } from 'react'
import { Button, Form, Table } from 'react-bootstrap'
import { Switch } from '@CommonComponents/buttons'
import { client } from '../utils'
import { symphonyServices as endpoints } from '../api_urls'
import { toast, Toaster } from '@CommonComponents/toast'
import PropTypes from 'prop-types'

/* jshint ignore:start */
const App = props => {
  const [assessmentDeliveryService, toggleAssessmentDeliveryService] = useState(
    props.assessmentDelivery
  )
  const [busy, setBusy] = useState(false)
  const [titlesUpdated, setTitlesUpdated] = useState(null)
  const [symphonyData, setSymphonyData] = useState(props.symphonyData)
  const [isDirty, setDirty] = useState(false)
  const { text } = window.MEButtons
  const feedback = {
    'data-busy-label': text('strSaving'),
    'data-success-label': text('strChangesSaved'),
    'data-failure-label': text('strSaveFailed'),
    'data-failure-text': text('strTryAgain'),
  }

  return (
    <React.Fragment>
      <Toaster />
      <h3>Symphony Services</h3>
      <Table size="sm" className="m-0">
        <tbody>
          <tr>
            <td>
              <Button
                type="button"
                variant="secondary"
                size="sm"
                className="btn-myed btn-default-myed btn-xs-myed"
                disabled={!assessmentDeliveryService || busy}
                onClick={async () => {
                  setBusy(true)
                  try {
                    const resp = await client.post(
                      endpoints.pushCourseAssessmentsToSymphony(),
                      {}
                    )
                    setTitlesUpdated(resp.data.titles)
                  } catch (err) {
                    setTitlesUpdated(null)
                    toast.error(`There was an error pushing the assessments. ${err}`)
                  } finally {
                    setBusy(false)
                  }
                }}
              >
                {busy && <i className="fa-regular fa-spinner-third fa-spin mr-3" />}
                Push Assessments
              </Button>
              {titlesUpdated && (
                <ul>
                  {titlesUpdated.map((title, idx) => (
                    <li key={idx} className="text-muted">
                      {title}
                    </li>
                  ))}
                </ul>
              )}
            </td>
            <td>
              <Switch
                {...feedback}
                label="Use Symphony assessment delivery"
                onChange={() => {
                  let data = {
                    symphony_assessment_delivery: !assessmentDeliveryService,
                  }
                  return client
                    .post(endpoints.updateAssessmentDeliveryService(), data)
                    .then(() => {
                      toggleAssessmentDeliveryService(
                        !assessmentDeliveryService
                      )
                    })
                    .catch(err => {
                      toast.error(`There was an error trying to toggle the service. ${err}`)
                      throw err
                    })
                }}
                checked={assessmentDeliveryService}
                disabled={busy}
              />
            </td>
          </tr>

          <tr>
            <td>
              <Button
                type="button"
                variant="secondary"
                size="sm"
                className="btn-myed btn-default-myed btn-xs-myed"
                disabled={busy}
                onClick={() => {
                  setBusy(true)
                  try {
                    client
                      .post(endpoints.pushCourseContentToSymphony())
                      .then(() => {
                        toast.success('Successfully posted to Symphony')
                      })
                  } catch (err) {
                    const msg =
                      err.response &&
                      err.response.data &&
                      err.response.data.error
                    console.log(err.response)
                    toast.error(msg || err.toString())
                  } finally {
                    setBusy(false)
                  }
                }}
              >
                Push Content
              </Button>
            </td>
            <td>
              <Switch
                {...feedback}
                data-failure-label="The Symphony reader is not available yet."
                data-failure-text="Not available"
                label="Use Symphony reader"
                onChange={() => {
                  alert(
                    "Who told you to toggle that switch? Did I tell you to toggle that switch? I never said toggle the switch! That switch is preposterous, inconceivable, unconscionable. You're flipping switches willy-nilly without a care in the world. Switches are not playthings! This is switch-toggling negligence of the most flagrant variety!"
                  )
                  // Nothing is saved, so the switch settles back to off.
                  throw new Error(
                    'The Symphony reader setting does not exist yet.'
                  )
                }}
                checked={false}
              />
            </td>
          </tr>
          <tr>
            <td colSpan="2" className="">
              <div className="mb-4">
                <div className="float-right">
                  <Button
                    type="button"
                    variant="secondary"
                    size="sm"
                    className="btn-myed btn-success-myed btn-sm-myed text-white"
                    disabled={!isDirty || busy}
                    onClick={async () => {
                      setBusy(true)
                      try {
                        const resp = await client.post(
                          endpoints.updateSymphonyData(),
                          {
                            symphony_data: symphonyData,
                          }
                        )
                        setDirty(false)
                        setSymphonyData(resp.data.symphony_data)
                      } catch (err) {
                        const msg =
                          err.response &&
                          err.response.data &&
                          err.response.data.error
                        toast.error(msg || err.toString())
                      } finally {
                        setBusy(false)
                      }
                    }}
                  >
                    Save
                  </Button>
                </div>
                <div className="mt-2">Configuration (yaml):</div>
              </div>
              <label htmlFor="config-yaml" className="hidden_label">
                Configuration YAML
              </label>
              <Form.Control
                id="config-yaml"
                as="textarea"
                style={{
                  minHeight: '180px',
                }}
                value={symphonyData}
                onChange={async e => {
                  setDirty(true)
                  setSymphonyData(e.target.value)
                }}
              />
            </td>
          </tr>
        </tbody>
      </Table>
    </React.Fragment>
  )
}

App.propTypes = {
  assessmentDelivery: PropTypes.bool.isRequired,
  symphonyData: PropTypes.string.isRequired,
}

export default App
